// src/contexts/AuthContext.jsx
import React, { createContext, useState, useEffect, useCallback, useMemo } from 'react'
import api from '../services/api'

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser]   = useState(() => {
    const stored = localStorage.getItem('user')
    return stored ? JSON.parse(stored) : null
  })
  const [ready, setReady] = useState(false)

  const permissions = useMemo(() => user?.permissions || [], [user])

  /** carica/valida utente corrente se ho un token salvato */
  const refresh = useCallback(async () => {
    const token = localStorage.getItem('accessToken')
    if (!token) { setUser(null); setReady(true); return }

    try {
      const { data } = await api.get('/auth/me')
      setUser(data.user)
      localStorage.setItem('user', JSON.stringify(data.user))
    } catch {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('user')
      setUser(null)
    } finally {
      setReady(true)
    }
  }, [])

  useEffect(() => {
    refresh()
  }, [refresh])

  const hasPermission = useCallback(
    (perm) => permissions.includes(perm),
    [permissions]
  )

  const login = useCallback(async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password })
    const { token, user } = data
    // salva token e utente
    localStorage.setItem('accessToken', token.token)
    localStorage.setItem('user', JSON.stringify(user))
    setUser(user)
    return user
  }, [])

  const logout = useCallback(async () => {
    try { await api.post('/auth/logout') } catch {}
    localStorage.removeItem('accessToken')
    localStorage.removeItem('user')
    setUser(null)
  }, [])

  const value = useMemo(() => ({
    user,
    ready,
    permissions,
    hasPermission,
    login,
    logout,
    refresh,
  }), [user, ready, permissions, hasPermission, login, logout, refresh])

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}
